import { Routes } from '@angular/router';

import { sloneekAdminCanActivateGuard, sloneekAdminCanMatchGuard } from '@app/admin/guards/sloneek-admin-or-translator.guard';
import { anonymousCanActivateGuard, anonymousCanMatchGuard } from '@app/auth/guards/anonymous.guard';
import { authCanActivateGuard, authCanMatchGuard } from '@app/auth/guards/auth.guard';
import { notTerminalCanActivateGuard, notTerminalCanMatchGuard } from '@app/auth/guards/is-not-terminal.guard';
import { PUBLIC_ROUTES } from './public/public.routes.misc';

export const appRoutes: Routes = [
  {
    path: 'admin',
    canActivate: [authCanActivateGuard, notTerminalCanActivateGuard(), sloneekAdminCanActivateGuard()],
    canMatch: [authCanMatchGuard(), notTerminalCanMatchGuard(), sloneekAdminCanMatchGuard()],
    loadChildren: () => import('./admin/admin.routes').then(m => m.adminRoutes),
  },
  // UNCOMMENT TO ENABLE UNDER CONSTRUCTION MODE
  // {path: '**', redirectTo: 'under-construction', pathMatch: 'full'},
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: 'app',
    canActivate: [authCanActivateGuard(), notTerminalCanActivateGuard()],
    canMatch: [authCanMatchGuard(), notTerminalCanMatchGuard()],
    loadChildren: () => import('./sloneek/sloneek.routes').then(m => m.sloneekRoutes),
  },
  {
    path: 'terminal',
    loadChildren: () => import('./terminal/terminal.routes').then(m => m.terminalRoutes),
  },
  {
    path: 'terminal-v2',
    loadChildren: () => import('./terminal-v2/terminal.routes').then(m => m.terminalV2Routes),
  },
  {
    path: PUBLIC_ROUTES.PUBLIC,
    loadChildren: () => import('./public/public.routes').then(m => m.publicRoutes),
  },
  {
    path: 'pre-boarding',
    loadChildren: () => import('./pre-hired/pre-hired.routes').then(m => m.preHiredRoutes),
    canMatch: [anonymousCanMatchGuard()],
    canActivate: [anonymousCanActivateGuard()],
  },
  {
    path: 'candidate',
    loadChildren: () => import('./ats-candidate/ats-candidate.routes').then(m => m.atsCandidateRoutes),
    canMatch: [anonymousCanMatchGuard()],
    canActivate: [anonymousCanActivateGuard()],
  },
  {
    path: '404',
    loadComponent: () =>
      import('./not-found-page/pages/not-found-layout-page/not-found-layout-page.component').then(m => m.NotFoundLayoutPageComponent),
  },
  { path: '', redirectTo: 'app', pathMatch: 'full' },
  // UNDER CONSTRUCTION
  {
    path: 'under-construction',
    loadComponent: () =>
      import('./auth-page-under-construction-component/auth-page-under-construction-component.component').then(
        m => m.AuthPageUnderConstructionComponentComponent,
      ),
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
